import { Star, Download, Shield, Smartphone } from 'lucide-react';

export const SocialProofBar = () => (
  <section className="py-6 border-b bg-card" data-testid="social-proof-bar">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-12 text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <div className="flex">
            {[...Array(5)].map((_, i) => <Star key={`rating-${i}`} className="h-4 w-4 fill-yellow-400 text-yellow-400" />)}
          </div>
          <span className="font-semibold">4.9/5 Rating</span>
        </div>
        <div className="flex items-center gap-2">
          <Download className="h-4 w-4 text-primary" />
          <span className="font-semibold">10,000+ Downloads</span>
        </div>
        <div className="flex items-center gap-2">
          <Shield className="h-4 w-4 text-secondary" />
          <span className="font-semibold">100% Private & Secure</span>
        </div>
        <div className="flex items-center gap-2">
          <Smartphone className="h-4 w-4 text-primary" />
          <span className="font-semibold">iOS & Android</span>
        </div>
      </div>
    </div>
  </section>
);
